import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared.module';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { InputsContactsComponent } from './inputs-contacts.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [
    InputsContactsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    NzFormModule,
    NzCheckboxModule,
    NzIconModule,
    NzTableModule,
    NzInputModule,
    NzButtonModule,
    NzEmptyModule,
    NzTypographyModule,
    NzToolTipModule,
    NzGridModule
  ],
  exports: [
    InputsContactsComponent
  ]
})
export class InputsContactsModule {}
